import { APIData } from './common.constant';

export const DefaultVersion = 2;

export const ProductInfo = () => ({
  productInfo: {
    api: APIData({}),
    OrderDate: '',
    OrderId: '',
    Product: [],
    StoreFrontData: {
      StorefrontName: '',
      CompanyId: '',
      WorkingName: '',
      EmailDomain: '',
      StorefrontApplicationSettings: new Map(),
    },
    StoreFrontURL: '',
    productIds: [],
    productMap: new Map(),
    productSet: new Set(),
    pdfInfo: {
      productId: 0,
      template: '',
    },
  },
});

export const PatientInfo = () => ({
  selectedPatientInfo: {
    api: APIData(),
    UserId: 0,
    PreName: '',
    FirstName: '',
    LastName: '',
    DOB: '',
    Age: 0,
    Gender: '',
    Height: '',
    Weight: '',
    BMI: '',
    City: '',
    State: '',
    StorefrontMedications: [],
    Allergies: [],
    PersonalMedicatoins: [],
    SeriousIllness: [],
    StartDateTime_UTC: '',
    EndDateTime_UTC: '',
  },
});

export const EmailReason = () => ({
  id: -1,
  label: '',
  value: -1,
  required: false,
  description: '',
});

export const AddProductInfo = () => ({
  addProductInfo: {
    api: APIData({}),
  }
});

export const IEmailTemplate = () => ({
  id: -1,
  pId: -1,
  name: '',
  title: '',
  label: '',
  body: '',
  subject: '',
  value: -1,

  EmailMessageId: -1,
  ProductId: -1,
  EmailTemplateTitle: '',
  EmailTemplateBody: '',
  EmailTemplateSubject: '',
});

export const IEmailTemplateWithProductId = () => {
  const _interface = {
    productId: 0,
    templateList: [IEmailTemplate()],
  };
  _interface.templateList = [];
  return _interface;
};

export const ISFEmailTemplateResponse = () => {
  const _interface = {
    storefrontName: '',
    templateWithProductIds: [IEmailTemplateWithProductId()],
  };
  _interface.templateWithProductIds = [];
  return _interface;
};

export const DefaultSFEmailTemplatesResponse = ISFEmailTemplateResponse();

export let SF_EMAIL_TEMPLATES_RESPONSE = ISFEmailTemplateResponse();
SF_EMAIL_TEMPLATES_RESPONSE = {
  storefrontName: 'GetContrave.com',
  templateWithProductIds: [
    {
      productId: 779,
      templateList: [
        {
          name: 'Approve Email Template',
          body: `<html>\n<head>\n\t<title></title>\n</head>\n<body style="height: auto; min-height: auto;">\n<p>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\nHi Abhisek,<br />\n<br />\nYour Contrave approve email test will be performed at a Lucid Test Center, and they will be contacting you soon to get you scheduled and answer any questions you may have. Just in case you don't hear from them or want to get started ASAP, here's their phone number: (623) 687-2386.<br />\n<br />\nThank you,<br />\n<br />\nLevaRx.com Patient Support<br />\nservice@LevaRx.com<br />\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<<DOCTOR>>\n(800) 835-6538</p>\n\n</body></html>`,
          subject: 'Contrave Approve Testing Center Info',
        },
      ],
    },
    {
      productId: 1075,
      templateList: [
        {
          name: 'Send Email Template',
          body: `<html>\n<head>\n\t<title></title>\n</head>\n<body style="height: auto; min-height: auto;">\n<p>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\nHi Abhisek02,<br />\n<br />\nYour Contrave send email test will be performed at a Lucid Test Center, and they will be contacting you soon to get you scheduled and answer any questions you may have. Just in case you don't hear from them or want to get started ASAP, here's their phone number: (623) 687-2386.<br />\n<br />\nThank you,<br />\n<br />\nLevaRx.com Patient Support<br />\nservice@LevaRx.com<br />\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n(800) 835-6538</p>\n\n</body></html>`,
          subject: 'Contrave Send Testing Center Info',
        },
      ],
    },
    {
      productId: 1271,
      templateList: [
        {
          name: 'Email Template',
          body: `<html>\n<head>\n\t<title></title>\n</head>\n<body style="height: auto; min-height: auto;">\n<p>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\nHi Abhisek03,<br />\n<br />\nYour Contrave email test will be performed at a Lucid Test Center, and they will be contacting you soon to get you scheduled and answer any questions you may have. Just in case you don't hear from them or want to get started ASAP, here's their phone number: (623) 687-2386.<br />\n<br />\nThank you,<br />\n<br />\nLevaRx.com Patient Support<br />\nservice@LevaRx.com<br />\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n(800) 835-6538</p>\n\n</body></html>`,
          subject: 'Contrave Email Testing Center Info',
        },
      ],
    },
    {
      productId: 1086,
      templateList: [
        {
          name: 'Deny Email Template',
          body: `<html>\n<head>\n\t<title></title>\n</head>\n<body style="height: auto; min-height: auto;">\n<p>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\nHi Abhisek04,<br />\n<br />\nYour Contrave deny email test will be performed at a Lucid Test Center, and they will be contacting you soon to get you scheduled and answer any questions you may have. Just in case you don't hear from them or want to get started ASAP, here's their phone number: (623) 687-2386.<br />\n<br />\nThank you,<br />\n<br />\nLevaRx.com Patient Support<br />\nservice@LevaRx.com<br />\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n(800) 835-6538</p>\n\n</body></html>`,
          subject: 'Contrave Deny Testing Center Info',
        },
      ],
    },
  ],
};

export const CRITICAL_FLAG = () => ({
  flagId: 0,
  flagText: '',
  required: true,
});

export const CRITICAL_FLAGS = () => {
  const _interface = {
    api: {
      ...APIData(),
      data: [CRITICAL_FLAG()],
    },
  };
  _interface.api.data = [];
  return _interface;
};

export const DOCTOR_FLAG = () => ({
  flagId: 0,
  flagText: '',
  required: true,
});

export const DOCTOR_FLAGS = () => {
  const _interface = {
    api: {
      ...APIData(),
      data: [DOCTOR_FLAG()],
    },
  };
  _interface.api.data = [];
  return _interface;
};

export const ORDER_FLAG = () => ({
  flagId: 0,
  productId: 0,
  questionId: 0,
  flagText: '',
  flagHeader: '', // flagText will be replaced with flagHeader in controller to match CRW-2659
  flaggedQuestion: '',
  flaggedAnswer: '',
  required: true,
});

export const PRESCRIBER_FLAG = () => ({
  ProductId: 0,
  QuestionId:  0,
  ConsultidconsultationId: 0,
  PrescriberFlagText: '',
  FlaggedQuestion: '',
  FlaggedAnswer: '',
  Required: true,
});

export const ORDER_AND_PRESCRIBER_FLAGS = () => {
  const _interface = {
    api: {
      ...APIData(),
      data: {
        OrderFlags: [''],
        OrderFlagsV2: [ORDER_FLAG()],
        PrescriberFlags: [PRESCRIBER_FLAG()],
        DoctorId: 0,
      }
    },
  };
  _interface.api.data.OrderFlags = [];
  _interface.api.data.OrderFlagsV2 = [];
  _interface.api.data.PrescriberFlags = [];
  return _interface;
};

export const SAVED_FLAG = () => ({
  id: 0,
  flagId: 0,
  flagType: '',
  checked: false,
  note: '',
  required: true,
  orderId: 0,
  productId: 0,
  questionId: 0,
  updatedBy: 0,
  updatedAt: '',
  responseId: '',
});

export const SAVED_FLAGS = () => {
  const _interface = {
    flagsCollection: new Map([
      ['', SAVED_FLAG()],
    ]),
    api: {
      ...APIData(),
      data: [SAVED_FLAG()],
    },
  };
  _interface.flagsCollection.delete('');
  _interface.api.data = [];
  return _interface;
};

export const ORDERS = () => ({
  scheduled: {
    collection: new Map([
      [0, {}],
    ]),
  },
  _async: {
    collection: new Map([
      [0, {}],
    ]),
  },
  all: {
    collection: new Map([
      [0, {}],
    ]),
  },
});

export const FLAG_TYPE = {
  ORDER: 'order',
  PRESCRIBER: 'prescriber',
};

export const LOADING_ROWS = [
  {
    key: 1,
  },
  {
    key: 2,
  },
  {
    key: 3,
  },
];
